import { NgClass, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent, IconSize } from '@ui/aos-lib';
import { RouteItem } from '../../../../routes/app.types';
import { SideMenuService } from '../side-menu.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IconComponent, NgTemplateOutlet, RouterLink, RouterLinkActive, TranslateModule, UpperCasePipe, NgClass],
  selector: 'aos-side-menu-expanded',
  styleUrl: './side-menu-expanded.component.scss',
  templateUrl: `./side-menu-expanded.component.html`
})
export class SideMenuExpandedComponent {
  @Input({ required: true }) menuItems: readonly RouteItem[] = [];

  private readonly sideMenuService = inject(SideMenuService);

  protected readonly expandButtonIconColor = 'currentColor';
  protected readonly expandButtonIconSize = IconSize.MD;
  protected readonly itemIconColor = 'currentColor';
  protected readonly itemIconSize = IconSize.MD;
  protected readonly subitemIconColor = 'currentColor';
  protected readonly subitemIconName = 'arrow-submenu';
  protected readonly subitemIconSize = IconSize.MD;

  protected currentSelectedItem: RouteItem | null = null;

  protected getClassBindings(selected: boolean, level: number): Record<string, boolean> {
    return {
      'aos-side-menu-item': level === 0,
      'aos-side-menu-item_selected': level === 0 && selected,
      'aos-side-menu-subitem': level === 1,
      'aos-side-menu-subitem_selected': level === 1 && selected
    };
  }

  protected handleClick(menuItem: RouteItem): void {
    this.expandMenuItem(menuItem);
    if (!menuItem.hasExternalLink && this.currentSelectedItem !== menuItem) {
      this.currentSelectedItem?.setSelectedState(false);
      menuItem.setSelectedState(true);
      this.currentSelectedItem = menuItem;
    }
  }

  protected toggleMenuHeader = (event: Event, menuItem: RouteItem): void => {
    event.preventDefault();
    menuItem.expanded = !menuItem.expanded;

    this.menuItems
      .filter((item: RouteItem) => {
        return item.group === menuItem.title;
      })
      .forEach((item: RouteItem) => {
        item.hidden = !item.hidden;
      });
    this.sideMenuService.saveMenuState(this.menuItems);
  };

  protected toggleMenuItem = (event: Event, menuItem: RouteItem): void => {
    event.preventDefault();
    menuItem.toggleExpansion();
    this.sideMenuService.saveMenuState(this.menuItems);
  };

  protected expandMenuItem(menuItem: RouteItem): void {
    menuItem.expandItem();
  }
}
